<link
  rel="stylesheet"
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
  integrity="sha512-1ycn6IcaQQ40/MKBW2W4Rhis/DbILU74C1vSrLJxCq57o941Ym01SwNsOMqvEBFlcgUa6xLiPY/NS5R+E6ztJQ=="
  crossorigin="anonymous"
  referrerpolicy="no-referrer" />
<!-- Footer -->
<footer class="text-center text-lg-start bg-light text-muted">
  <!-- Section: Social media -->
  <section
    class="d-flex justify-content-center justify-content-lg-between p-4 border-bottom">
    <!-- Left -->
    <div class="me-5 d-none d-lg-block">
      <span>Get connected with us on social networks:</span>
    </div>
    <!-- Left -->

    <!-- Right -->
    <div>
      <a
        target="_blank"
        href="https://www.facebook.com/groups/639693347011547"
        class="me-4 text-reset">
        <i class="fab fa-facebook-f"></i>
      </a>
      <a
        target="_blank"
        href="https://twitter.com/DsaanaO"
        class="me-4 text-reset">
        <i class="fab fa-twitter"></i>
      </a>
      <a
        target="_blank"
        href="https://www.instagram.com/dsaananj/"
        class="me-4 text-reset">
        <i class="fab fa-instagram"></i>
      </a>
      <!-- <a href="/" class="me-4 text-reset">
        <i class="fab fa-linkedin"></i>
      </a> -->
    </div>
    <!-- Right -->
  </section>
  <!-- Section: Social media -->

  <!-- Section: Links  -->
  <section class="">
    <div class="container text-center text-md-start mt-5">
      <!-- Grid row -->
      <div class="row mt-3">
        <!-- Grid column -->
        <div class="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
          <!-- Content -->
          <h6 class="text-uppercase fw-bold mb-4">
            <i class="fas fa-gem me-3"></i>DSAANA
          </h6>
          <p>
            Devanga Sowdeshwari Amman Association of North America (DSAANA) is a
            non-profit organization with a mission to build a vibrant Kannada
            Devanga Community and promote rich culture in the North America.
          </p>
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="col-md-5 col-lg-4 col-xl-4 mx-auto mb-4">
          <!-- Links -->
          <h6 class="text-uppercase fw-bold mb-4">Useful Links</h6>
          <p>
            <a href="/signup" class="text-reset">Members Signup</a>
          </p>
          <p>
            <a href="/login" class="text-reset">Member Login</a>
          </p>

          <p>
            <a href="/contact" class="text-reset">Contact Us</a>
          </p>
          <p>
            <a href="/" class="text-reset">Home</a>
          </p>
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
          <!-- Links -->
          <h6 class="text-uppercase fw-bold mb-4">Contact</h6>
          <span class="row">
            <div class="col-1">
              <i class="fas fa-home me-3"></i>
            </div>
            <div class="col-10">
              Registered Address :<br />
              10 Lily Lane, Piscataway, NJ 08854
            </div>
          </span>

          <br />
          <span class="row">
            <div class="col-1">
              <i class="fas fa-envelope me-3"></i>
            </div>
            <div class="col-10">Admin@dsaana.org</div>
          </span>
          <br />
          <span class="row">
            <div class="col-1">
              <i class="fas fa-phone me-3"></i>
            </div>
            <div class="col-10">+1 616 7 DSAANA</div>
          </span>
        </div>
        <!-- Grid column -->
      </div>
      <!-- Grid row -->
    </div>
  </section>
  <!-- Section: Links  -->

  <!-- Copyright -->
  <div class="row">
    <div
      class="col-6 text-center p-4"
      style="background-color: rgba(0, 0, 0, 0.05);">
      © 2021 Copyright:
      <a class="text-reset fw-bold" href="/">DSAANA.ORG</a>
    </div>
    <div
      class="col-6 text-center p-4"
      style="background-color: rgba(0, 0, 0, 0.05);">
      Powered By:
      <a class="text-reset fw-bold" href="https://itprozcorp.com">
        ITPROZ CORPORATIONS, LLC
      </a>
    </div>
  </div>
  <!-- Copyright -->
</footer>
<!-- Footer -->
